import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NotificationsService } from './notifications.service';
import { NotificationModel } from './notifications';
import * as _ from 'lodash';
import { IdbService } from 'src/app/services/idb.service';
import { environment } from 'src/environments/environment';
import { IdbNotificationsResponse } from 'src/app/model/idb';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { DatePipe } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
import { severityColorMap } from 'src/app/model/global-interface';

@Component({
    selector: 'app-notifications-center',
    templateUrl: './notifications-center.component.html',
    styleUrls: ['./notifications-center.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class NotificationsCenterComponent implements OnInit, OnDestroy{

  oldNotif: NotificationModel[] = [];

  newNotif: NotificationModel[] = [];

  severityColorMap = severityColorMap;

  days: string[] = [];
  ready: boolean = false;

  constructor(private notifications: NotificationsService, private idb:IdbService, private localStorageS:LocalStorageService,
    private datePipe: DatePipe,
  ){

  }

  ngOnInit(): void {
    let userData = this.localStorageS.getUserData();
    this.idb.getAllData(environment.idbTables.Notifications).then((data:IdbNotificationsResponse[])=>{

      let tempOldNotif: NotificationModel[] = [];
      data.filter(x=> x.item.userId == userData?.id && x.item.viewed == true).forEach(notif=>{
        //console.warn(notif)
        let dateOnly = new Date(Number(notif.item.date)).toLocaleDateString();
        notif.item.dateOnly = dateOnly;
        if(!this.days.includes(dateOnly)){
          this.days.push(dateOnly);
        } 
        //this.oldNotif.push(notif.item);
        //notif.item.date = this.datePipe.transform(notif.item.date, 'dd-MM-yyy hh:mm') ?? '';
        tempOldNotif.push(notif.item);
      });  
      // sort data
      this.oldNotif = tempOldNotif.sort((a, b) => Number(b.date) - Number(a.date));

      this.days = this.days.reverse();
      // and assign them
      //this.oldNotif = tempOldNotif;
      
      let tempNewNotif: NotificationModel[] = [];
      data.filter(x=> x.item.userId == userData?.id && x.item.viewed != true).forEach(notif=>{
        //console.warn(notif)

        //notif.item.date = this.datePipe.transform(notif.item.date, 'dd-MM-yyy hh:mm') ?? '';
        this.newNotif.push(notif.item);
      });

      this.newNotif = this.newNotif.sort((a, b) => Number(b.date) - Number(a.date));
      // and assign them
      //this.newNotif = tempNewNotif;

      setTimeout(() => {
        
        this.ready = true;
      }, 0);
    })

    this.notifications.markAsViewedNotifications();

    

  }

  filterByDate(date:string):NotificationModel[]{
    return this.oldNotif.filter(x=> x.dateOnly == date);
  }


  ngOnDestroy(): void {
  
  }

}
